/* ag-p30-pdp: mobile polish lane script (2026-09-30 r3). Deferred. */
(function () {
  "use strict";
  if (window.__agP30Pdp) return;
  window.__agP30Pdp = true;

  var ATC_SEL = 'form[action*="/cart/add"] button[name="add"], button[name="add"].add-to-cart';

  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---- D3 / FIT-RULES.md: years from title first, size from title only ---- */
  function formatMetafieldYear(raw) {
    if (raw === null || raw === undefined) return "";
    var s = String(raw).trim();
    if (!s) return "";
    s = s.replace(/\s*[–-]\s*/g, "–");
    s = s.replace(/–Running$/i, "–present");
    s = s.replace(/–present$/i, "–present");
    return s;
  }

  function normalizeYearKey(s) {
    return String(s || "").replace(/\s+/g, "").replace(/present/ig, "present").toLowerCase();
  }

  function exactTitleMatch(title, re) {
    var m = title.match(re);
    return m ? m[0] : "";
  }

  function parseFitFacts(title, metafieldYear) {
    var out = { years: "", size: "", qualifier: "", yearFromTitle: false, conflict: false };
    title = title ? String(title) : "";

    var sizeM = title.match(/(\d+(?:\.\d+)?)\s*(?:inch(?:es)?|[″”"\u2033]|in\b)/i);
    if (sizeM) out.size = sizeM[1] + "\u2033";

    var quals = [];
    var pre = exactTitleMatch(title, /Pre-Facelift/i);
    if (pre) {
      quals.push(pre);
    } else {
      var face = exactTitleMatch(title, /Facelift/i);
      if (face) quals.push(face);
    }
    var old = exactTitleMatch(title, /\bOld\b/i);
    if (old) quals.push(old);
    var neu = exactTitleMatch(title, /\bNew\b/i);
    if (neu) quals.push(neu);
    out.qualifier = quals.join(" \u00b7 ");

    var years = "";
    var m = title.match(/\((20\d{2})\s*[–-]\s*(20\d{2})\)/);
    if (m) years = m[1] + "\u2013" + m[2];
    if (!years) {
      m = title.match(/\((20\d{2})\s*[–-]\s*present\)/i);
      if (m) years = m[1] + "\u2013present";
    }
    if (!years) {
      m = title.match(/\((20\d{2})\s*[–-]\s*Running\)/i);
      if (m) years = m[1] + "\u2013present";
    }
    if (!years) {
      m = title.match(/\((20\d{2})\s*[–-]\s*Facelift\)/i);
      if (m) years = m[1];
    }
    if (!years) {
      m = title.match(/\((20[1-3]\d)\)/);
      if (m) years = m[1];
    }
    if (!years) {
      m = title.match(/\b(20\d{2})\s*[–-]\s*(20\d{2})\b/);
      if (m) years = m[1] + "\u2013" + m[2];
    }
    if (!years) {
      m = title.match(/\b(20\d{2})\s*[–-]\s*present\b/i);
      if (m) years = m[1] + "\u2013present";
    }
    if (!years) {
      m = title.match(/\b(20\d{2})\s*[–-]\s*Running\b/i);
      if (m) years = m[1] + "\u2013present";
    }
    if (!years) {
      m = title.match(/\b(201\d|202\d|2030)\b/);
      if (m) years = m[1];
    }

    var mf = formatMetafieldYear(metafieldYear);
    if (years) {
      out.years = years;
      out.yearFromTitle = true;
      if (mf && normalizeYearKey(years) !== normalizeYearKey(mf)) out.conflict = true;
    } else if (mf) {
      out.years = mf;
    }
    return out;
  }
  window.__agP30ParseFit = parseFitFacts;

  function enhanceFitChip() {
    var fitEl = qs("script[data-ag-fit]");
    var fit = {};
    if (fitEl) {
      try { fit = JSON.parse(fitEl.textContent); } catch (e) { fit = {}; }
    }
    var h1 = qs(".sf-prod__info h1, h1.product-single__title, h1");
    var title = (fit.title || "").trim()
      || (h1 && (h1.textContent || "").trim())
      || document.title || "";
    var parsed = parseFitFacts(title, fit.yearRange);
    var make = (fit.make || "").trim();
    if (make === "Universal") make = "";
    var model = (fit.model || "").trim();
    var years = parsed.years;
    var size = parsed.size;
    var qualifier = parsed.qualifier;
    if (!make && !model && !years && !size && !qualifier) return;

    var chip = qs("[data-agpe-fitchip], .agpe-fitchip");
    /* SSR 2026-10-05: the server already printed exactly this line from armour.fit_chip (parity-tested) — leave it. */
    if (chip && chip.getAttribute("data-ag-fit-ssr") === "1") return;
    var row = qs("[data-agpe-pricerow]");
    if (!chip && row && row.parentNode) {
      chip = document.createElement("div");
      chip.className = "agpe-fitchip";
      chip.setAttribute("data-agpe-fitchip", "");
      chip.innerHTML = '<span class="agpe-fitchip__txt"></span>';
      row.insertAdjacentElement("afterend", chip);
    }
    var txt = chip && qs(".agpe-fitchip__txt", chip);
    if (!txt) return;

    var head = "";
    if (make || model) head = (make + (model ? " " + model : "")).replace(/\s+/g, " ").trim();
    var bits = [];
    if (years) bits.push(years);
    if (size) bits.push(size);
    if (qualifier) bits.push(qualifier);
    if (head) {
      var html = "<b>Fits</b> " + head;
      if (years) html += " \u00b7 " + years;
      if (size) html += ' \u00b7 <span data-ag-screen-size>' + size + "</span>";
      if (qualifier) html += " \u00b7 " + qualifier;
      txt.innerHTML = html;
    } else {
      txt.textContent = bits.join(" \u00b7 ");
    }
    if (parsed.conflict) chip.setAttribute("data-ag-p30-year-conflict", "1");
    else chip.removeAttribute("data-ag-p30-year-conflict");
    chip.setAttribute("data-ag-p30-years", years || "");
    chip.setAttribute("data-ag-p30-size", size || "");
    chip.setAttribute("data-ag-p30-qual", qualifier || "");
  }

  function placeFitAndBuyinfo() {
    var row = qs("[data-agpe-pricerow]");
    var chip = qs("[data-agpe-fitchip], .agpe-fitchip");
    var fitnav = qs("[data-agpe-fitnav]");
    if (row && row.parentNode) {
      // SSR pass 2026-10-04: ag-pdp-head renders row → chip → fitnav in place; only move when out of order (old templates)
      if (chip && row.nextElementSibling !== chip) row.insertAdjacentElement("afterend", chip);
      var after = chip || row;
      if (fitnav && after.nextElementSibling !== fitnav) after.insertAdjacentElement("afterend", fitnav);
    }
    qsa(".agpe-askfit").forEach(function (a) {
      if (fitnav && fitnav.contains(a)) return;
      a.setAttribute("hidden", "");
    });
    var realAtc = qs(ATC_SEL);
    var atcForm = realAtc && (realAtc.closest("product-form") || realAtc.closest("form"));
    var buyinfo = qs(".agpe-buyinfo");
    if (buyinfo && atcForm && atcForm.parentNode) {
      atcForm.insertAdjacentElement("afterend", buyinfo);
    }
  }

  /* D1: ATC pending/duplicate-guard JS removed. Minimog product-form.js
     toggleSpinner() owns .product-form.adding for the request lifetime.
     Busy UI is CSS-only in ag-p30-pdp.css. Never mutate ATC text/children. */

  function pingStickyReconcile() {
    try { window.dispatchEvent(new Event("agpe-sticky-reconcile")); } catch (e0) {}
  }

  /* ---- P6: honest rating ON the Judge.me badge (badge stays the hit target) ---- */
  function parseJmBadge(badge) {
    var avg = null, count = null;
    if (badge) {
      var label = badge.getAttribute("aria-label") || badge.getAttribute("title") || "";
      var text = (badge.textContent || "").replace(/\s+/g, " ").trim();
      var avgAttr = badge.getAttribute("data-average-rating") || badge.getAttribute("data-rating") || "";
      var countAttr = badge.getAttribute("data-number-of-reviews") || badge.getAttribute("data-reviews-count") || "";
      if (avgAttr) avg = parseFloat(avgAttr);
      if (countAttr !== "") count = parseInt(countAttr, 10);
      var m = label.match(/([0-9]+(?:\.[0-9]+)?)\s*out of\s*5/i)
        || label.match(/rated\s+([0-9]+(?:\.[0-9]+)?)/i)
        || text.match(/([0-9]+(?:\.[0-9]+)?)\s*out of\s*5/i);
      if (avg == null && m) avg = parseFloat(m[1]);
      var c = label.match(/(\d+)\s*reviews?/i) || text.match(/(\d+)\s*reviews?/i);
      if (count == null && c) count = parseInt(c[1], 10);
      if (count == null && /\b1 review\b/i.test(text + " " + label)) count = 1;
      if (count == null && /no reviews|0 review/i.test(text + " " + label)) count = 0;
    }
    qsa('script[type="application/ld+json"]').forEach(function (s) {
      if (avg != null && count != null) return;
      try {
        var d = JSON.parse(s.textContent);
        var agg = d && (d.aggregateRating || (d.mainEntity && d.mainEntity.aggregateRating));
        if (!agg) return;
        if (avg == null && agg.ratingValue != null) avg = parseFloat(agg.ratingValue);
        if (count == null && (agg.reviewCount != null || agg.ratingCount != null)) {
          count = parseInt(agg.reviewCount || agg.ratingCount, 10);
        }
      } catch (e) {}
    });
    if (avg != null && (isNaN(avg) || avg < 0 || avg > 5)) avg = null;
    return { avg: avg, count: count };
  }

  function paintRating() {
    var badge = qs(".sf-prod__info .jdgm-preview-badge, .sf-prod__info .jdgm-prev-badge, .main-product__block .jdgm-preview-badge");
    if (!badge) return;
    badge.classList.remove("ag-p30-rating-hidden");
    badge.removeAttribute("hidden");
    if (badge.style && badge.style.display === "none") badge.style.display = "";
    var info = parseJmBadge(badge);
    var host = badge.querySelector("a[href]") || badge;
    var line = qs(".ag-p30-rating", badge);
    if (!info || info.count === 0) {
      if (line) line.hidden = true;
      return;
    }
    var avgStr = (info.avg != null && !isNaN(info.avg)) ? info.avg.toFixed(1) : "";
    var countStr = info.count != null
      ? (info.count === 1 ? "1 review" : info.count + " reviews")
      : "";
    if (!avgStr && !countStr) return;
    var label = avgStr && countStr
      ? "\u2605 " + avgStr + " \u00b7 " + countStr
      : (avgStr ? "\u2605 " + avgStr : countStr);
    if (!line) {
      line = document.createElement("span");
      line.className = "ag-p30-rating";
      host.appendChild(line);
    } else if (host !== badge && line.parentNode !== host) {
      host.appendChild(line);
    }
    line.hidden = false;
    line.textContent = label;
    if (!badge.__agP30Jump) {
      badge.__agP30Jump = true;
      badge.addEventListener("click", function () {
        var a = badge.querySelector("a[href]");
        var href = (a && a.getAttribute("href")) || "";
        var dest = null;
        if (href.charAt(0) === "#") dest = document.getElementById(href.slice(1));
        if (!dest) dest = qs(".jdgm-rev-widg, #judgeme_product_reviews, [id*='judgeme_section_review_widget'], [id*='judgeme_reviews']");
        if (!dest) return;
        var html = document.documentElement;
        html.classList.remove("ag-addon-modal-open", "prevent-scroll");
        document.body.classList.remove("ag-addon-modal-open");
        document.body.style.position = "";
        var prev = html.style.scrollBehavior;
        html.style.scrollBehavior = "auto";
        dest.scrollIntoView();
        html.style.scrollBehavior = prev;
        html.setAttribute("data-ag-p30-review-jump", dest.id || "1");
        pingStickyReconcile();
        requestAnimationFrame(pingStickyReconcile);
      });
    }
  }

  /* ---- P7 / D6: distinct media (no clones) + realIndex ---- */
  function galleryCounter() {
    var root = qs(".sf-product-media__mobile");
    if (!root) return;
    var pager = qs(".swiper-container.f-media-mobile, .f-media-mobile", root);
    if (!pager) return;
    var countEl = qs(".ag-p30-gcount", root);
    if (!countEl) {
      countEl = document.createElement("div");
      countEl.className = "ag-p30-gcount";
      countEl.setAttribute("aria-live", "polite");
      root.appendChild(countEl);
    }
    function slides() {
      var seen = {};
      var n = 0;
      function consider(s) {
        if (!s || !s.getAttribute) return;
        if (s.classList && s.classList.contains("swiper-slide-duplicate")) return;
        var key = s.getAttribute("data-swiper-slide-index");
        if (key == null || key === "") {
          var img = s.querySelector && s.querySelector("img");
          key = (img && (img.getAttribute("data-media-id")
            || img.getAttribute("data-src")
            || img.getAttribute("src")
            || img.currentSrc)) || "";
        }
        if (key === "") key = "n" + n;
        if (seen[key]) return;
        seen[key] = true;
        n += 1;
      }
      var wrap = qs(".swiper-wrapper", pager);
      qsa(".swiper-slide", wrap || pager).forEach(consider);
      if (n) return n;
      qsa(".sf-prod-media-item", root).forEach(function (item) {
        var slide = item.classList.contains("swiper-slide") ? item : item.closest(".swiper-slide");
        consider(slide || item);
      });
      return n;
    }
    function activeIndex() {
      if (pager.swiper && typeof pager.swiper.realIndex === "number") {
        return pager.swiper.realIndex + 1;
      }
      var act = qs(".swiper-slide-active:not(.swiper-slide-duplicate)", pager)
        || qs(".swiper-slide-active", pager);
      if (!act) return 1;
      var i = act.getAttribute("data-swiper-slide-index");
      if (i != null && i !== "") return parseInt(i, 10) + 1;
      return 1;
    }
    function paint() {
      var n = slides();
      if (!n) {
        if (!countEl.hidden) countEl.hidden = true;
        return;
      }
      var idx = activeIndex();
      if (idx < 1) idx = 1;
      if (idx > n) idx = ((idx - 1) % n) + 1;
      var next = idx + " / " + n;
      if (countEl.hidden) countEl.hidden = false;
      if (countEl.textContent !== next) countEl.textContent = next;
    }
    function bindSwiper() {
      if (!pager.swiper) return;
      if (typeof pager.swiper.allowTouchMove !== "undefined") pager.swiper.allowTouchMove = true;
      if (pager.swiper.on && !pager.__agP30SlideBound) {
        pager.__agP30SlideBound = true;
        pager.swiper.on("slideChange", paint);
        pager.swiper.on("slideChangeTransitionEnd", paint);
      }
    }
    paint();
    bindSwiper();
    if (!pager.__agP30Mo) {
      pager.__agP30Mo = new MutationObserver(function () { paint(); });
      pager.__agP30Mo.observe(pager, { attributes: true, subtree: true, attributeFilter: ["class"] });
    }
  }

  /* ---- P8 / D9: accordions only if normalised text AND hrefs match ---- */
  function normText(el) {
    return ((el && (el.innerText || el.textContent)) || "").replace(/\s+/g, " ").trim();
  }
  function hrefList(el) {
    return qsa("a[href]", el).map(function (a) { return a.getAttribute("href") || ""; });
  }
  function sameHrefs(a, b) {
    if (a.length !== b.length) return false;
    var i;
    for (i = 0; i < a.length; i++) if (a[i] !== b[i]) return false;
    return true;
  }
  function textClose(a, b) {
    a = (a || "").replace(/\s+/g, " ").trim();
    b = (b || "").replace(/\s+/g, " ").trim();
    if (a === b) return true;
    if (!a.length) return !b.length;
    if (a.replace(/\s+/g, "") === b.replace(/\s+/g, "")) return true;
    return Math.abs(a.length - b.length) / a.length <= 0.01;
  }
  function unwrapDetails(details) {
    var parent = details.parentNode;
    if (!parent) return;
    while (details.firstChild) {
      var child = details.firstChild;
      if (child.nodeName === "SUMMARY") {
        while (child.firstChild) parent.insertBefore(child.firstChild, details);
        details.removeChild(child);
      } else {
        parent.insertBefore(child, details);
      }
    }
    parent.removeChild(details);
  }

  function collapseLongform() {
    var root = qs("#ag-screen-protector");
    if (!root || root.getAttribute("data-ag-p30-acc") === "1") return;
    var beforeLen = (root.innerText || "").length;
    var beforeHrefs = hrefList(root);
    var card = qs(".card", root) || root;

    function wrap(nodes, headingEl) {
      nodes = nodes.filter(Boolean);
      if (!nodes.length) return null;
      if (!headingEl) {
        headingEl = qs(".h1, .row-2-title, .fitment-title, .sec-title, .faq-title, h2, h3", nodes[0]);
      }
      if (!headingEl || !headingEl.parentNode) return null;
      var first = nodes[0];
      if (!first.parentNode) return null;
      var beforeT = nodes.map(normText).join(" ").replace(/\s+/g, " ").trim();
      var beforeH = [];
      nodes.forEach(function (n) { beforeH = beforeH.concat(hrefList(n)); });

      var details = document.createElement("details");
      details.className = "ag-p30-acc";
      var summary = document.createElement("summary");
      first.parentNode.insertBefore(details, first);
      summary.appendChild(headingEl);
      details.appendChild(summary);
      nodes.forEach(function (n) {
        if (n && n !== headingEl && n.parentNode) details.appendChild(n);
      });
      details.open = true;
      var afterT = normText(details);
      var afterH = hrefList(details);
      if (!sameHrefs(beforeH, afterH)) {
        unwrapDetails(details);
        return null;
      }
      if (!textClose(beforeT, afterT)) details.setAttribute("data-ag-p30-text-drift", "1");
      return details;
    }

    var hero = qs(".hero", card);
    var h1 = hero && qs(".h1", hero);
    var features = qs(".feature-grid", card);
    var row2 = qs(".row-2", card);
    var rowTitle = row2 && qs(".row-2-title", row2);
    var fitment = qs(".fitment", card);
    var fitTitle = fitment && qs(".fitment-title", fitment);
    var viewAll = qs(".view-all-cta", card);
    var secHead = qs(".sec-head", card);
    var secTitle = secHead && qs(".sec-title", secHead);
    var install = qs(".install", card);
    var faq = qs(".faq", card);
    var faqTitle = faq && qs(".faq-title", faq);

    var made = [];
    var d;
    d = wrap(hero ? [hero] : [], h1); if (d) made.push(d);
    d = wrap([features, row2], rowTitle); if (d) made.push(d);
    d = wrap([fitment, viewAll], fitTitle); if (d) made.push(d);
    d = wrap([secHead, install], secTitle); if (d) made.push(d);
    d = wrap(faq ? [faq] : [], faqTitle); if (d) made.push(d);

    made.forEach(function (el) { el.open = true; });
    var afterLen = (root.innerText || "").length;
    var afterHrefs = hrefList(root);
    var hrefOk = sameHrefs(beforeHrefs, afterHrefs);
    var textOk = beforeLen > 0 && Math.abs(afterLen - beforeLen) / beforeLen <= 0.01;
    if (!hrefOk || !textOk) {
      made.slice().reverse().forEach(unwrapDetails);
      root.setAttribute("data-ag-p30-acc", "0");
      root.setAttribute("data-ag-p30-hrefs-ok", hrefOk ? "1" : "0");
      return;
    }
    made.forEach(function (el, i) { el.open = i === 0; });
    root.setAttribute("data-ag-p30-acc", "1");
    root.setAttribute("data-ag-p30-hrefs-ok", "1");
    root.setAttribute("data-ag-p30-before-len", String(beforeLen));
    root.setAttribute("data-ag-p30-after-len", String(afterLen));
    if (made[0]) made[0].open = true;
  }

  function promoteLcp() {
    var root = qs(".sf-product-media__mobile");
    if (!root) return;
    var featured = qs(".swiper-slide-active img", root)
      || qs(".sf-prod-media-item img", root)
      || qs("img", root);
    var first = qs("img", root);
    [first, featured].forEach(function (img) {
      if (!img) return;
      img.setAttribute("fetchpriority", "high");
      if (img.getAttribute("loading") === "lazy") img.setAttribute("loading", "eager");
    });
  }

  function enableExistingZoom() {
    qsa("media-gallery").forEach(function (g) {
      if (g.getAttribute("data-enable-image-zoom") === "false") {
        g.setAttribute("data-enable-image-zoom", "true");
      }
    });
    var wrap = qs(".sf-prod-template");
    if (wrap) wrap.classList.add("enable-zoom");
  }

  function boot() {
    try {
      enhanceFitChip();
      placeFitAndBuyinfo();
      try { promoteLcp(); } catch (eL0) {}
    } catch (e0) {}
    /* orchestrator 2026-09-30: removed a blanket iframe hider (any src/id/class containing "preview"/"pbar") — it
       existed for preview-bar testing and could hide real embeds on live. */
    window.setTimeout(function () {
      try { collapseLongform(); } catch (eL) {}
      try { paintRating(); } catch (eR) {}
      try { galleryCounter(); } catch (eG) {}
      try { enableExistingZoom(); } catch (eZ) {}
      try { promoteLcp(); } catch (eLcp) {}
      try { enhanceFitChip(); } catch (eF) {}
    }, 0);
    window.setTimeout(function () { try { collapseLongform(); } catch (e2) {} }, 600);
    window.setTimeout(paintRating, 1200);
    window.setTimeout(paintRating, 2800);
    /* orchestrator 2026-09-30: paint as soon as Judge.me actually renders (slow networks); one-shot, and it disconnects
       before painting so our own insertion cannot re-trigger it. */
    try {
      var jmRoot = qs(".sf-prod__info") || document.body;
      var jmObs = new MutationObserver(function () {
        if (qs(".sf-prod__info .jdgm-prev-badge__stars, .sf-prod__info [data-number-of-reviews]")) { jmObs.disconnect(); paintRating(); }
      });
      jmObs.observe(jmRoot, { childList: true, subtree: true });
      window.setTimeout(function () { jmObs.disconnect(); }, 20000);
    } catch (eO) {}
    window.setTimeout(galleryCounter, 600);
    window.setTimeout(galleryCounter, 1800);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
